export const styles = {
  container: {
    position: 'absolute',
    top: '0',
    left: '0',
    width: '100vw',
    height: '100vh',
    background: 'rgba(39, 55, 84, 0.16)',
    zIndex: 999999999999,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  card: {
    width: '632px',
    minHeight: '255px',
    background: 'white',
    borderRadius: '8px',
    padding: '25px',
  },
  content: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  closeContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'end',
  },
  close: {
    cursor: 'pointer',
  },
  title: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '24px',
    fontWeight: 700,
    marginBottom: '10px',
  },
  message: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  buttonsWrapper: {
    width: '330px',
    display: 'flex',
    justifyContent: 'space-around',
    marginTop: '35px',
  },
  cancel: {
    height: '40px',
    width: '130px',
    borderRadius: '12px',
    border: '1px solid black',
    padding: '10px, 12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    fontWeight: '800',
  },
  confirm: {
    height: '40px',
    width: '130px',
    background: 'rgba(238, 67, 96, 1)',
    color: 'white',
    borderRadius: '12px',
    border: '1px solid rgba(238, 67, 96, 1)',
    padding: '10px, 12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    fontWeight: '800',
  },
}
